"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _formik = require("formik");
var _react = require("react");
var getKey = function getKey(obj, errorKey) {
  var selectorKey = '';
  if (obj !== null && typeof obj === 'object') {
    var _Object$entries = Object.entries(obj),
      _Object$entries2 = (0, _slicedToArray2["default"])(_Object$entries, 1),
      _Object$entries2$ = (0, _slicedToArray2["default"])(_Object$entries2[0], 2),
      key = _Object$entries2$[0],
      value = _Object$entries2$[1];
    selectorKey = selectorKey.concat(getKey(value, key));
  }
  return errorKey ? "".concat(errorKey).concat(selectorKey && ".".concat(selectorKey)) : selectorKey;
};
/**
 *  ErrorFocus can be used in combination with Formik to focus input elements that have an error state by using its formik field name.
 *  It also supports other elements like divs, but in order for this to work you need to pass a *data-error-focus* prop with
 *  the formik field name as value.
 */
function ErrorFocus(_ref) {
  var _ref$scrollIntoViewOp = _ref.scrollIntoViewOptions,
    scrollIntoViewOptions = _ref$scrollIntoViewOp === void 0 ? {
      block: 'center',
      inline: 'center'
    } : _ref$scrollIntoViewOp;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    isSubmitting = _useFormikContext.isSubmitting,
    isValidating = _useFormikContext.isValidating,
    errors = _useFormikContext.errors;
  (0, _react.useEffect)(function () {
    var hasErrors = Object.keys(errors).length > 0;
    if (hasErrors && isSubmitting && !isValidating) {
      var key = getKey(errors);
      var selector = "[name=\"".concat(key, "\"]");
      var errorElement = document.querySelector(selector);
      if (errorElement) {
        // for some input elements that are hidden like react-select, we'll fallback to scroll their parent into view
        if (errorElement.type === 'hidden') {
          var _ref2;
          (_ref2 = errorElement.parentElement) === null || _ref2 === void 0 ? void 0 : _ref2.scrollIntoView(scrollIntoViewOptions);
        } else {
          errorElement.focus();
        }
      } else {
        // we prefer to focus input elements, but sometimes we need to scroll to another element that contains the error
        var elementId = document.querySelector("[data-error-focus=\"".concat(key, "\"]"));
        elementId === null || elementId === void 0 ? void 0 : elementId.scrollIntoView(scrollIntoViewOptions);
      }
    }
  }, [isSubmitting, isValidating, errors, scrollIntoViewOptions]);
  return null;
}
var _default = exports["default"] = ErrorFocus;
//# sourceMappingURL=ErrorFocus.js.map